import { MSFORMS_PREFIX, READ_MORE_URL } from '../common';
import {
  MissingAnnotationEmptyState,
  useEntity,
} from '@backstage/plugin-catalog-react';

export const MSFormContent = ({ name }: { name: string }) => {
  const { entity } = useEntity();

  const annotationKey = `${MSFORMS_PREFIX}/${name}`;

  const annotation = (entity.metadata.annotations || {})[annotationKey];
  if (!annotation) {
    return (
      <MissingAnnotationEmptyState
        annotation={annotationKey}
        readMoreUrl={READ_MORE_URL}
      />
    );
  }

  const url = new URL(annotation);
  url.searchParams.append('embed', 'true');

  return (
    <iframe
      title="Embedded form"
      width="100%"
      height="100%"
      src={url.toString()}
      style={{
        border: 'none',
        maxWidth: '100%',
        maxHeight: '100vh',
        margin: 0,
      }}
      allowFullScreen
    />
  );
};
